import {ModalProvider} from "./modal-context";
import {registryFactory} from "@common/ui-components/registry/registry-factory";

export const modalRegistry = registryFactory({
    className: "modal-registry",
    Provider: ModalProvider,
});
